// These constants are used to define the types of prompts in dialogs with the assistant robot.
export const PROMPT_EXPLANATION_TYPE = 'explanation';
export const PROMPT_ASSISTANT_TYPE = 'assistant';

// Session Block Type:
export const SESSION_BLOCK_QUIZ_TYPE = 'quiz';
export const SESSION_BLOCK_TRAINING_TYPE = 'training';
export const SESSION_BLOCK_REVIEW_TYPE = 'review';
